import * as React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const StyledArticleTypeImage = styled.img`
  width: 100%;
  max-width: 100px;
  color: white;
`;

interface IArticleTypeImage extends React.ImgHTMLAttributes<HTMLImageElement> {}

export const ArticleTypeImage: React.FC<IArticleTypeImage> = (props) => {
  return (
    <StyledWrapper>
      <StyledArticleTypeImage {...props} alt={props.alt} />
    </StyledWrapper>
  );
};
